<template>
  <div class="mse-sign">
    <div id="big-sign">
      <div id="main-sign">
        <div style="margin-top: 20px;background: #fff;">
          <van-collapse v-model="activePanels">
            <van-collapse-item name="base">
               <div class="table-main-sign1-sign">
                <p>
                  <a>手机号码</a>
                  <input class="inputs-t" type="text" v-model="form.ownerPhone" @blur="fetchInfoByPhone"  maxlength="11"/>
                </p>
              </div>
              <div class="table-main-sign1-sign">
                <p>
                  <a>姓名</a>
                  <input class="inputs-t" type="text" v-model="form.ownerName" />
                </p>
              </div>
              <div class="table-main-sign1-sign">
                <p>
                  <a>车牌号码</a>
                  <input class="inputs-t" type="text" v-model="form.plateNo" placeholder="如：京A12345" />
                </p>
              </div>
             
              
              <!-- 地区：市固定为潍坊市，县为下拉选择 -->
              <div class="table-main-sign1-sign">
                <p>
                  <a>地区</a>
                  <span class="region-selects">
                    <select class="inputs-t county-select" v-model="form.county">
                       <option value="">请选择县/区</option>
                       <option v-for="c in weifangCounties" :key="c" :value="c">{{ c }}</option>
                     </select>
                   </span>
                </p>
              </div>
            </van-collapse-item>

            <van-collapse-item name="vehicle">
              <div slot="title">
                <div class="section-bar car">
                  <div class="section-title-line">
                    <span>车辆档案</span>
                  </div>

                </div>
              </div>
               <div class="section-panel vehicle">
                 <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">行驶证1-4页</div>
                     <div class="archive-content">
                       <div class="imgs-grid">
                         <div class="img-item" :class="{ uploaded: isUploadedKey('drivingLicense1') }"><img :src="form.drivingLicense1" class="img-sign" @click="selectUpload('drivingLicense1')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('drivingLicense2') }"><img :src="form.drivingLicense2" class="img-sign" @click="selectUpload('drivingLicense2')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('drivingLicense3') }"><img :src="form.drivingLicense3" class="img-sign" @click="selectUpload('drivingLicense3')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('drivingLicense4') }"><img :src="form.drivingLicense4" class="img-sign" @click="selectUpload('drivingLicense4')" /></div>
                       </div>
                     </div>
                   </div>
                 </div>

                 <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">机动车登记证书1-4页</div>
                     <div class="archive-content">
                       <div class="imgs-grid">
                         <div class="img-item" :class="{ uploaded: isUploadedKey('registration1') }"><img :src="form.registration1" class="img-sign" @click="selectUpload('registration1')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('registration2') }"><img :src="form.registration2" class="img-sign" @click="selectUpload('registration2')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('registration3') }"><img :src="form.registration3" class="img-sign" @click="selectUpload('registration3')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('registration4') }"><img :src="form.registration4" class="img-sign" @click="selectUpload('registration4')" /></div>
                       </div>
                     </div>
                   </div>
                 </div>

                 <!-- 交强险（1张） -->
                 <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">交强险</div>
                     <div class="archive-content">
                       <div class="imgs-grid">
                         <div class="img-item" :class="{ uploaded: isUploadedKey('insuranceCompulsory') }"><img :src="form.insuranceCompulsory" class="img-sign" @click="selectUpload('insuranceCompulsory')" /></div>
                       </div>
                     </div>
                   </div>
                 </div>

                 <!-- 商业险（1张） -->
                 <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">商业险</div>
                     <div class="archive-content">
                       <div class="imgs-grid">
                         <div class="img-item" :class="{ uploaded: isUploadedKey('insuranceCommercial') }"><img :src="form.insuranceCommercial" class="img-sign" @click="selectUpload('insuranceCommercial')" /></div>
                       </div>
                     </div>
                   </div>
                 </div>

                 <!-- 承运人（3张） -->
                 <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">承运人</div>
                     <div class="archive-content">
                       <div class="imgs-grid">
                         <div class="img-item" :class="{ uploaded: isUploadedKey('insuranceCarrier1') }"><img :src="form.insuranceCarrier1" class="img-sign" @click="selectUpload('insuranceCarrier1')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('insuranceCarrier2') }"><img :src="form.insuranceCarrier2" class="img-sign" @click="selectUpload('insuranceCarrier2')" /></div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('insuranceCarrier3') }"><img :src="form.insuranceCarrier3" class="img-sign" @click="selectUpload('insuranceCarrier3')" /></div>
                       </div>
                     </div>
                   </div>
                 </div>

                 <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">车辆运输证</div>
                     <div class="archive-content">
                       <div class="img-item" :class="{ uploaded: isUploadedKey('transportPermit') }"><img :src="form.transportPermit" class="img-sign" @click="selectUpload('transportPermit')" /></div>
                     </div>
                   </div>
                 </div>

                 <div class="table-main-sign1-sign">
                   <p>
                     <span>是否有外检材料</span>
                     <span>
                       <input type="radio" id="extNo" value="0" v-model="form.hasExternal" />
                       否
                       <input style="margin-left: 0.5rem;" type="radio" id="extYes" value="1" v-model="form.hasExternal" />
                       是
                     </span>
                   </p>
                 </div>

                 <template v-if="form.hasExternal==='1'">
                   <div class="table-main-sign1-sign img-but">
                     <div class="archive-item">
                       <div class="archive-label">外检表</div>
                       <div class="archive-content">
                         <div class="img-item" :class="{ uploaded: isUploadedKey('externalInspectionForm') }">
                           <img :src="form.externalInspectionForm" class="img-sign" @click="selectUpload('externalInspectionForm')" />
                         </div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('externalInspectionForm2') }">
                           <img :src="form.externalInspectionForm2" class="img-sign" @click="selectUpload('externalInspectionForm2')" />
                         </div>
                       </div>
                     </div>
                   </div>
                   <div class="table-main-sign1-sign img-but">
                     <div class="archive-item">
                       <div class="archive-label">上线单</div>
                       <div class="archive-content">
                         <div class="imgs-grid">
                           <div class="img-item" :class="{ uploaded: isUploadedKey('onlineSheet') }">
                             <img :src="form.onlineSheet" class="img-sign" @click="selectUpload('onlineSheet')" />
                           </div>
                           <div class="img-item" :class="{ uploaded: isUploadedKey('onlineSheet2') }">
                             <img :src="form.onlineSheet2" class="img-sign" @click="selectUpload('onlineSheet2')" />
                           </div>
                           <div class="img-item" :class="{ uploaded: isUploadedKey('onlineSheet3') }">
                             <img :src="form.onlineSheet3" class="img-sign" @click="selectUpload('onlineSheet3')" />
                           </div>
                           <div class="img-item" :class="{ uploaded: isUploadedKey('onlineSheet4') }">
                             <img :src="form.onlineSheet4" class="img-sign" @click="selectUpload('onlineSheet4')" />
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </template>

                <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">车辆一致性证书</div>
                     <div class="archive-content">
                       <div class="img-item" :class="{ uploaded: isUploadedKey('coc') }"><img :src="form.coc" class="img-sign" @click="selectUpload('coc')" /></div>
                     </div>
                   </div>
                 </div>

                <div class="table-main-sign1-sign img-but">
                   <div class="archive-item">
                     <div class="archive-label">购车发票</div>
                     <div class="archive-content">
                       <div class="img-item" :class="{ uploaded: isUploadedKey('invoice') }"><img :src="form.invoice" class="img-sign" @click="selectUpload('invoice')" /></div>
                     </div>
                   </div>
                 </div>
              </div>
            </van-collapse-item>

            <van-collapse-item name="driver">
              <div slot="title">
                <div class="section-bar driver">
                  <div class="section-title-line">
                    <span>驾驶员档案</span>
                  </div>

                </div>
              </div>
              <div class="section-panel driver">
               <div class="table-main-sign1-sign">
                 <p>
                   <span>车主和驾驶员为一人?</span>
                   <span>
                     <input type="radio" value="1" v-model="driver_relation" />
                     是
                     <input style="margin-left: 0.5rem;" type="radio" value="0" v-model="driver_relation" />
                     否
                   </span>
                 </p>
               </div>

              <template v-if="driver_relation==='1'">
                <div class="table-main-sign1-sign img-but">
                  <div class="archive-item">
                    <div class="archive-label">车主身份证</div>
                    <div class="archive-content">
                      <div class="img-item" :class="{ uploaded: isUploadedKey('form.ownerIdCard') }">
                        <img :src="form.ownerIdCard" class="img-sign" @click="selectUpload('form.ownerIdCard')" />
                      </div>
                      <div class="img-item" :class="{ uploaded: isUploadedKey('form.ownerIdCardBack') }">
                        <img :src="form.ownerIdCardBack" class="img-sign" @click="selectUpload('form.ownerIdCardBack')" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-main-sign1-sign img-but">
                  <div class="archive-item">
                    <div class="archive-label">上岗证</div>
                    <div class="archive-content">
                      <div class="img-item" :class="{ uploaded: isUploadedKey('form.ownJobCert') }">
                        <img :src="form.ownJobCert" class="img-sign" @click="selectUpload('form.ownJobCert')" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-main-sign1-sign img-but">
                  <div class="archive-item">
                    <div class="archive-label">驾驶证</div>
                    <div class="archive-content">
                      <div class="img-item" :class="{ uploaded: isUploadedKey('form.ownDriverLicense') }">
                        <img :src="form.ownDriverLicense" class="img-sign" @click="selectUpload('form.ownDriverLicense')" />
                      </div>
                      <div class="img-item" :class="{ uploaded: isUploadedKey('form.ownDriverLicenseBack') }">
                        <img :src="form.ownDriverLicenseBack" class="img-sign" @click="selectUpload('form.ownDriverLicenseBack')" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="table-main-sign1-sign">
                  <p>
                    <a>手机号码</a>
                    <input class="inputs-t" type="text" v-model="form.ownPhone" />
                  </p>
                </div> -->
              </template>

              <template v-else>
                <div class="table-main-sign1-sign img-but">
                  <div class="archive-item">
                    <div class="archive-label">车主身份证</div>
                    <div class="archive-content">
                      <div class="img-item" :class="{ uploaded: isUploadedKey('form.ownerIdCard') }">
                        <img :src="form.ownerIdCard" class="img-sign" @click="selectUpload('form.ownerIdCard')" />
                      </div>
                      <div class="img-item" :class="{ uploaded: isUploadedKey('form.ownerIdCardBack') }">
                        <img :src="form.ownerIdCardBack" class="img-sign" @click="selectUpload('form.ownerIdCardBack')" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table-main-sign1-sign" style="border-top: .2rem solid #f4f4f4;">
                  <p>
                    <span>是否有两个驾驶员</span>
                    <span>
                      <input type="radio" value="0" v-model="two_drivers" />
                      否
                      <input style="margin-left: 0.5rem;" type="radio" value="1" v-model="two_drivers" />
                      是
                    </span>
                  </p>
                </div>

                <div class="table-kfp"><p>1号驾驶员</p></div>
                <div class="table-main-sign1-sign img-but">
                  <div class="archive-item">
                    <div class="archive-label">身份证</div>
                    <div class="archive-content">
                      <div class="img-item" :class="{ uploaded: isUploadedKey('driver1.id_card') }">
                        <img :src="driver1.id_card" class="img-sign" @click="selectUpload('driver1.id_card')" />
                      </div>
                       <div class="img-item" :class="{ uploaded: isUploadedKey('driver1.id_card_back') }">
                        <img :src="driver1.id_card_back" class="img-sign" @click="selectUpload('driver1.id_card_back')" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-main-sign1-sign img-but">
                  <div class="archive-item">
                    <div class="archive-label">上岗证</div>
                    <div class="archive-content">
                      <div class="img-item" :class="{ uploaded: isUploadedKey('driver1.job_cert') }">
                        <img :src="driver1.job_cert" class="img-sign" @click="selectUpload('driver1.job_cert')" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-main-sign1-sign img-but">
                  <div class="archive-item">
                    <div class="archive-label">驾驶证</div>
                    <div class="archive-content">
                      <div class="img-item" :class="{ uploaded: isUploadedKey('driver1.driver_license') }">
                        <img :src="driver1.driver_license" class="img-sign" @click="selectUpload('driver1.driver_license')" />
                      </div>
                         <div class="img-item" :class="{ uploaded: isUploadedKey('driver1.driver_license_back') }">
                        <img :src="driver1.driver_license_back" class="img-sign" @click="selectUpload('driver1.driver_license_back')" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-main-sign1-sign">
                  <p>
                    <a>手机号码</a>
                    <input class="inputs-t" type="text" v-model="driver1.phone" />
                  </p>
                </div>

                <template v-if="two_drivers==='1'">
                  <div class="table-kfp"><p>2号驾驶员</p></div>
                  <div class="table-main-sign1-sign img-but">
                    <div class="archive-item">
                      <div class="archive-label">身份证</div>
                      <div class="archive-content">
                        <div class="img-item" :class="{ uploaded: isUploadedKey('driver2.id_card') }">
                          <img :src="driver2.id_card" class="img-sign" @click="selectUpload('driver2.id_card')" />
                        </div>
                        <div class="img-item" :class="{ uploaded: isUploadedKey('driver2.id_card_back') }">
                          <img :src="driver2.id_card_back" class="img-sign" @click="selectUpload('driver2.id_card_back')" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-main-sign1-sign img-but">
                    <div class="archive-item">
                      <div class="archive-label">上岗证</div>
                      <div class="archive-content">
                        <div class="img-item" :class="{ uploaded: isUploadedKey('driver2.job_cert') }">
                           <img :src="driver2.job_cert" class="img-sign" @click="selectUpload('driver2.job_cert')" />
                         </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-main-sign1-sign img-but">
                    <div class="archive-item">
                      <div class="archive-label">驾驶证</div>
                      <div class="archive-content">
                        <div class="img-item" :class="{ uploaded: isUploadedKey('driver2.driver_license') }">
                           <img :src="driver2.driver_license" class="img-sign" @click="selectUpload('driver2.driver_license')" />
                         </div>
                        <div class="img-item" :class="{ uploaded: isUploadedKey('driver2.driver_license_back') }">
                           <img :src="driver2.driver_license_back" class="img-sign" @click="selectUpload('driver2.driver_license_back')" />
                         </div>
                      </div>
                    </div>
                  </div>
                  <div class="table-main-sign1-sign">
                    <p>
                      <a>手机号码</a>
                      <input class="inputs-t" type="text" v-model="driver2.phone" />
                    </p>
                  </div>
                </template>
              </template>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
    </div>
    <input ref="fileInput" type="file" style="display:none" accept="image/*"   multiple="false" @change="onFileChange" />
    <div class="button-ce-s"><button class="button-sign" @click="handleSubmit">提交档案</button></div>
  </div>
</template>

<script>
/* global Global */
import request from '@/utils/request'
import { Notify } from 'vant'

const PLACEHOLDER = 'https://jt11.oss-cn-beijing.aliyuncs.com/edu/chifeng/selfimg.jpeg'
const JOB_CER = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E4%B8%8A%E5%B2%97%E8%AF%81.jpg"
const ID_CARD_FRONT = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E8%BA%AB%E4%BB%BD%E8%AF%81%20%E6%AD%A3%E9%9D%A2.jpg"
const ID_CARD_BACK = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E8%BA%AB%E4%BB%BD%E8%AF%81%E5%8F%8D%E9%9D%A2.jpg"
const DRIVER_LICENSE =      "https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E9%A9%BE%E9%A9%B6%E8%AF%81%E6%AD%A3%E9%9D%A2.jpg"
const DRIVER_LICENSE_BACK = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E9%A9%BE%E9%A9%B6%E8%AF%81%E5%8F%8D%E9%9D%A2.jpg"

const DRIVER_LICENSE_1 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%811.jpg"
const DRIVER_LICENSE_2 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%812.jpg"
const DRIVER_LICENSE_3 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%813.png"
const DRIVER_LICENSE_4 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%814.jpg"

const REGISTRATION_1 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A61-2%E9%A1%B5.png"
const REGISTRATION_2 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A63-4%E9%A1%B5.png"
const REGISTRATION_3 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A63.jpg"
const REGISTRATION_4 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A63.png"

const INSURANCE_COMPULSORY = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%BA%A4%E5%BC%BA%E9%99%A9.jpg"
const INSURANCE_COMMERCIAL = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%95%86%E4%B8%9A%E9%99%A9.jpg"

const INSURANCE_CARRIER_1 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%89%BF%E8%BF%90%E4%BA%BA1.jpg"
const INSURANCE_CARRIER_2 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%89%BF%E8%BF%90%E4%BA%BA2.jpg"
const INSURANCE_CARRIER_3 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%89%BF%E8%BF%90%E4%BA%BA3.jpg"
const TRANSPORT_PERMIT = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%BD%A6%E8%BE%86%E8%BF%90%E8%BE%93%E8%AF%81.jpg"
const EXTERNAL_INSPECTION_FORM = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%A4%96%E6%A3%80%E8%A1%A81.jpg"
const EXTERNAL_INSPECTION_FORM_2 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%A4%96%E6%A3%80%E8%A1%A82.jpg"
const ONLINE_SHEET = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%B8%8A%E7%BA%BF%E5%8D%951.jpg"
const ONLINE_SHEET_2 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%B8%8A%E7%BA%BF%E5%8D%952.jpg"
const ONLINE_SHEET_3 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%B8%8A%E7%BA%BF%E5%8D%953.jpg"
const ONLINE_SHEET_4 = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%B8%8A%E7%BA%BF%E5%8D%954.jpg"



const COC = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%BC%BA%E5%88%B6%E6%80%A7%E4%BA%A7%E5%93%81%E8%AE%A4%E8%AF%81%E8%BD%A6%E8%BE%86%E4%B8%80%E8%87%B4%E6%80%A7%E8%AF%81%E4%B9%A6.jpg"
const INVOCICE = "https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%8F%91%E7%A5%A8.jpg"
export default {
  components: { [Notify.name]: Notify },
  data() {
    return {
      isFetching: false ,// 防止重复请求的标志
      currentKey: '',
      activePanels: ['base','vehicle','driver'],
      weifangCounties: ['潍城区','寒亭区','坊子区','奎文区','青州市','诸城市','寿光市','安丘市','高密市','昌邑市','临朐县','昌乐县','滨海区','峡山区'],
      form: {
        id:'',
        ownerName: '',
        plateNo: '',
        ownerPhone: '',
        city: '潍坊市',
        county: '',
        ownerIdCard: ID_CARD_FRONT,
        ownerIdCardBack: ID_CARD_BACK,
        ownJobCert: JOB_CER,
        ownDriverLicense: DRIVER_LICENSE,
        ownDriverLicenseBack: DRIVER_LICENSE_BACK,
        coc:COC,
        invoice:INVOCICE,

        // vehicle
        drivingLicense1: DRIVER_LICENSE_1,
        drivingLicense2: DRIVER_LICENSE_2,
        drivingLicense3: DRIVER_LICENSE_3,
        drivingLicense4: DRIVER_LICENSE_4,
        registration1: REGISTRATION_1,
        registration2: REGISTRATION_2,
        registration3: REGISTRATION_3,
        registration4: REGISTRATION_4,
        insuranceCompulsory: INSURANCE_COMPULSORY,
        insuranceCommercial: INSURANCE_COMMERCIAL,
        insuranceCarrier1: INSURANCE_CARRIER_1,
        insuranceCarrier2: INSURANCE_CARRIER_2,
        insuranceCarrier3: INSURANCE_CARRIER_3,
        transportPermit: TRANSPORT_PERMIT,
        hasExternal: '0',
        externalInspectionForm: EXTERNAL_INSPECTION_FORM,
        externalInspectionForm2: EXTERNAL_INSPECTION_FORM_2,
        onlineSheet: ONLINE_SHEET,
        onlineSheet2: ONLINE_SHEET_2,
        onlineSheet3: ONLINE_SHEET_3,
        onlineSheet4: ONLINE_SHEET_4,
      },
      driver_relation: '1', // 1=同一人, 0=不同人
      two_drivers: '0', // 0/1
      driver1: { id_card: ID_CARD_FRONT, id_card_back:ID_CARD_BACK,job_cert: JOB_CER, driver_license: DRIVER_LICENSE,driver_license_back:DRIVER_LICENSE_BACK, phone: '' },
      driver2: { id_card: ID_CARD_FRONT, id_card_back:ID_CARD_BACK,job_cert: JOB_CER, driver_license: DRIVER_LICENSE,driver_license_back:DRIVER_LICENSE_BACK, phone: '' },
    }
  },
  created() {
    // 记录初始占位值快照，避免示例图URL变化导致误判
    this._initial = JSON.parse(JSON.stringify({
      form: this.form,
      driver1: this.driver1,
      driver2: this.driver2,
    }))
  },
  methods: {
    // 优化后的手机号失焦获取信息方法
    fetchInfoByPhone() {
      // 验证手机号格式
      if (!this.validPhone(this.form.ownerPhone)) {
        Notify('请输入正确的手机号码')
        return
      }
      
      // 防止重复请求
      if (this.isFetching) return
      
      this.isFetching = true
      
      // 调用后台接口获取信息
      this.fetchUserInfoByPhone(this.form.ownerPhone);
    },
    fetchUserInfoByPhone(phone) {
      // 显示加载状态
      const loading = Notify({ type: 'loading', message: '获取信息中...', duration: 0 })
      const urls = Global.env + Global.apiCore.getVdaMain
      request({
        url: urls, // 假设的用户信息接口
        method: 'post', // 改为POST请求
        headers: { 'Content-Type': 'application/json' }, // 修改为JSON格式
        data: {
          ownerPhone: phone // 传递手机号参数
        }
      }).then(res => {
        // 清除加载状态
        Notify.clear(loading)
        
        if (res.resultCode === '1000') {
          // 成功获取信息后填充表单
          const userInfo = res.data

              // 检查数据是否为空数组
          if (Array.isArray(userInfo) && userInfo.length === 0) {
            this.isFetching = false
            
            return;
          }
          // eslint-disable-next-line no-console
          console.log('userInfo-------------------:',userInfo)
          if(userInfo ) {
  // eslint-disable-next-line no-console
            console.log('userInfo---------111----------:',userInfo)
            this.form.applyStatus = userInfo.applyStatus;
            if(this.form.applyStatus == 0) {
                this.clearForm();
                this.isFetching = false
                Notify({ type: 'success', message: '档案待审核不需要填写' })
                return;
            }
            if(this.form.applyStatus == 1) {
                this.clearForm();
                this.isFetching = false
                Notify({ type: 'success', message: '档案已审核通过' })

            }
            this.isFetching = false
            this.fillFormWithUserInfo(res)
            Notify({ type: 'success', message: '信息获取成功' })
          }else {
            this.isFetching = false
          } 
        }
      }).catch(error => {
        // 清除加载状态
        Notify.clear(loading)
        this.isFetching = false
        Notify('网络异常，请稍后重试',error)
      })
    },
    clearForm() {
      this.form = {
        id: '',
        ownerName: '',
        plateNo: '',
        ownerPhone: '',
        city: '潍坊市',
        county: '',
        ownerIdCard: ID_CARD_FRONT,
        ownerIdCardBack: ID_CARD_BACK,
        ownJobCert: JOB_CER,
        ownDriverLicense: DRIVER_LICENSE,
        ownDriverLicenseBack: DRIVER_LICENSE_BACK,
        coc: COC,
        invoice: INVOCICE,

        // vehicle
        drivingLicense1: DRIVER_LICENSE_1,
        drivingLicense2: DRIVER_LICENSE_2,
        drivingLicense3: DRIVER_LICENSE_3,
        drivingLicense4: DRIVER_LICENSE_4,
        registration1: REGISTRATION_1,
        registration2: REGISTRATION_2,
        registration3: REGISTRATION_3,
        registration4: REGISTRATION_4,
        insuranceCompulsory: INSURANCE_COMPULSORY,
        insuranceCommercial: INSURANCE_COMMERCIAL,
        insuranceCarrier1: INSURANCE_CARRIER_1,
        insuranceCarrier2: INSURANCE_CARRIER_2,
        insuranceCarrier3: INSURANCE_CARRIER_3,
        transportPermit: TRANSPORT_PERMIT,
        hasExternal: '0',
        externalInspectionForm: EXTERNAL_INSPECTION_FORM,
        externalInspectionForm2: EXTERNAL_INSPECTION_FORM_2,
        onlineSheet: ONLINE_SHEET,
        onlineSheet2: ONLINE_SHEET_2,
        onlineSheet3: ONLINE_SHEET_3,
        onlineSheet4: ONLINE_SHEET_4
      };  // 这里应该用分号结束对象赋值
      
      // 以下几行是独立的赋值语句，应该用分号结束，而不是逗号
      this.driver_relation = '1'; // 1=同一人, 0=不同人
      this.two_drivers = '0'; // 0/1
      this.driver1 = { 
        id_card: ID_CARD_FRONT, 
        id_card_back: ID_CARD_BACK,
        job_cert: JOB_CER, 
        driver_license: DRIVER_LICENSE,
        driver_license_back: DRIVER_LICENSE_BACK, 
        phone: '' 
      };
      this.driver2 = { 
        id_card: ID_CARD_FRONT, 
        id_card_back: ID_CARD_BACK,
        job_cert: JOB_CER, 
        driver_license: DRIVER_LICENSE,
        driver_license_back: DRIVER_LICENSE_BACK, 
        phone: '' 
      };
    },
    // 填充表单数据的方法
    fillFormWithUserInfo(userInfo) {
      const data = userInfo.data || {}
      const driverArchive = data.driverArchive || {}
      const vehicleArchive = data.vehicleArchive || {}
      
      // 填充基础信息
      this.form.id = data.id 
      this.form.ownerName = data.ownerName || this.form.ownerName
      this.form.plateNo = data.plateNo || this.form.plateNo
      this.form.ownerPhone = data.ownerPhone || this.form.ownerPhone
      this.form.county = data.county || this.form.county
      
      // 填充车主身份证信息
      this.form.ownerIdCard = data.ownerIdCard || this.form.ownerIdCard
      this.form.ownerIdCardBack = data.ownerIdCardBack || this.form.ownerIdCardBack
      this.form.ownJobCert = data.jobCert || this.form.ownJobCert
      this.form.ownDriverLicense = data.driverLicense || this.form.ownDriverLicense
      this.form.ownDriverLicenseBack = data.driverLicenseBack || this.form.ownDriverLicenseBack
      
      // 填充车辆档案信息
      this.form.drivingLicense1 = vehicleArchive.drivingLicense1 || this.form.drivingLicense1
      this.form.drivingLicense2 = vehicleArchive.drivingLicense2 || this.form.drivingLicense2
      this.form.drivingLicense3 = vehicleArchive.drivingLicense3 || this.form.drivingLicense3
      this.form.drivingLicense4 = vehicleArchive.drivingLicense4 || this.form.drivingLicense4
      
      this.form.registration1 = vehicleArchive.registration1 || this.form.registration1
      this.form.registration2 = vehicleArchive.registration2 || this.form.registration2
      this.form.registration3 = vehicleArchive.registration3 || this.form.registration3
      this.form.registration4 = vehicleArchive.registration4 || this.form.registration4
      
      this.form.insuranceCompulsory = vehicleArchive.insuranceCompulsory || this.form.insuranceCompulsory
      this.form.insuranceCommercial = vehicleArchive.insuranceCommercial || this.form.insuranceCommercial
      this.form.insuranceCarrier1 = vehicleArchive.insuranceCarrier1 || this.form.insuranceCarrier1
      this.form.insuranceCarrier2 = vehicleArchive.insuranceCarrier2 || this.form.insuranceCarrier2
      this.form.insuranceCarrier3 = vehicleArchive.insuranceCarrier3 || this.form.insuranceCarrier3
      
      this.form.transportPermit = vehicleArchive.transportPermit || this.form.transportPermit
      this.form.hasExternal = vehicleArchive.hasExternal || this.form.hasExternal
      this.form.externalInspectionForm = vehicleArchive.externalInspectionForm || this.form.externalInspectionForm
      this.form.externalInspectionForm2 = vehicleArchive.externalInspectionForm2 || this.form.externalInspectionForm2
      this.form.onlineSheet = vehicleArchive.onlineSheet || this.form.onlineSheet
      this.form.onlineSheet2 = vehicleArchive.onlineSheet2 || this.form.onlineSheet2
      this.form.onlineSheet3 = vehicleArchive.onlineSheet3 || this.form.onlineSheet3
      this.form.onlineSheet4 = vehicleArchive.onlineSheet4 || this.form.onlineSheet4
      
      this.form.coc = vehicleArchive.coc || this.form.coc
      this.form.invoice = vehicleArchive.invoice || this.form.invoice
      
      // 处理车主与驾驶员关系
      this.driver_relation = data.ownerIsDriver.toString() || this.driver_relation
      
      // 填充驾驶员1信息
      this.driver1.id_card = driverArchive.idCard || this.driver1.id_card
      this.driver1.id_card_back = driverArchive.idCardBack || this.driver1.id_card_back
      this.driver1.job_cert = driverArchive.jobCert || this.driver1.job_cert
      this.driver1.driver_license = driverArchive.driverLicense || this.driver1.driver_license
      this.driver1.driver_license_back = driverArchive.driverLicenseBack || this.driver1.driver_license_back
      this.driver1.phone = driverArchive.phone || this.driver1.phone
      
      // 处理是否有两名驾驶员
      this.two_drivers = data.twoDrivers.toString() || this.two_drivers
      
      // 如果有两名驾驶员，填充驾驶员2信息
      if (this.two_drivers === '1') {
        this.driver2.id_card = driverArchive.twoIdCard || this.driver2.id_card
        this.driver2.id_card_back = driverArchive.twoIdCardBack || this.driver2.id_card_back
        this.driver2.job_cert = driverArchive.twoJobCert || this.driver2.job_cert
        this.driver2.driver_license = driverArchive.twoDriverLicense || this.driver2.driver_license
        this.driver2.driver_license_back = driverArchive.twoDriverLicenseBack || this.driver2.driver_license_back
        this.driver2.phone = driverArchive.twoPhone || this.driver2.phone
      }
    },
    // 基于初始快照的更稳健“是否已上传”判断
    isUploadedKey(key) {
      const segs = key.split('.')
      const cur = segs.length === 2 ? this[segs[0]][segs[1]] : this.form[key]
      let init
      if (segs.length === 2) {
        init = this._initial && this._initial[segs[0]] ? this._initial[segs[0]][segs[1]] : undefined
      } else {
        init = this._initial && this._initial.form ? this._initial.form[key] : undefined
      }
      return !!(cur && cur !== init && cur !== PLACEHOLDER && cur !== 'null' && cur !== 'undefined')
    },
    selectUpload(key) {
      this.currentKey = key
      this.$refs.fileInput.dispatchEvent(new MouseEvent('click'))
    },
    // 新增：前端压缩（最长边 1920，质量 0.75，目标 ≤1MB）
    async compressImage(file, opts = {}) {
      const maxSide = (opts.maxSide === undefined || opts.maxSide === null) ? 1920 : opts.maxSide
      let quality = (opts.quality === undefined || opts.quality === null) ? 0.75 : opts.quality
      const minQuality = (opts.minQuality === undefined || opts.minQuality === null) ? 0.5 : opts.minQuality
      const sizeTarget = (opts.sizeTarget === undefined || opts.sizeTarget === null) ? 1024 * 1024 : opts.sizeTarget
      const { img, width, height } = await this.loadImage(file)
      const scale = Math.min(1, maxSide / Math.max(width, height))
      let targetW = Math.round(width * scale)
      let targetH = Math.round(height * scale)
      // eslint-disable-next-line no-console
      console.log('[compress] start', { width, height, maxSide, quality, sizeTarget, scale, targetW, targetH })
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const toBlobAsync = (q) => new Promise(resolve => {
        canvas.toBlob(b => resolve(b || null), 'image/jpeg', q)
      })
      const redraw = () => {
        canvas.width = targetW
        canvas.height = targetH
        ctx.clearRect(0, 0, targetW, targetH)
        ctx.drawImage(img, 0, 0, targetW, targetH)
      }
      redraw()
      let blob = await toBlobAsync(quality)
      // eslint-disable-next-line no-console
      console.log('[compress] initial blob size', blob && blob.size)
      let guard = 0
      while (blob && blob.size > sizeTarget && guard < 6) {
        if (quality > minQuality) {
          quality = Math.max(minQuality, quality * 0.85)
        } else {
          targetW = Math.round(targetW * 0.9)
          targetH = Math.round(targetH * 0.9)
          redraw()
        }
        blob = await toBlobAsync(quality)
        guard++
        // eslint-disable-next-line no-console
        console.log('[compress] iter', guard, { size: blob && blob.size, quality, target: targetW + 'x' + targetH })
      }
      if (!blob) {
        const dataUrl = canvas.toDataURL('image/jpeg', quality)
        blob = await (await fetch(dataUrl)).blob()
      }
      // eslint-disable-next-line no-console
      console.log('[compress] done', { size: blob && blob.size, final: targetW + 'x' + targetH, quality })
      return blob
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
          const width = img.naturalWidth || img.width
          const height = img.naturalHeight || img.height
          URL.revokeObjectURL(url)
          resolve({ img, width, height })
        }
        img.onerror = (e) => {
          URL.revokeObjectURL(url)
          reject(e)
        }
        img.src = url
      })
    },
    // 将上传流程接入压缩
    async onFileChange(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        Notify(`请上传图片文件（JPG、PNG等格式），当前文件"${file.name}"不符合要求`)
        e.target.value = ''
        return
      }

      const threshold = 1024 * 1024 // 1MB
      // eslint-disable-next-line no-console
      console.log('[upload] original size', file.size, 'threshold', threshold)
      let uploadBlob = file
      const start = Date.now()
      try {
        if (file.size > threshold) {
          // eslint-disable-next-line no-console
          console.log('[upload] trigger compress (> threshold)')
          uploadBlob = await this.compressImage(file, { maxSide: 1920, quality: 0.75, minQuality: 0.5, sizeTarget: threshold })
          // eslint-disable-next-line no-console
          console.log('[upload] compressed size', uploadBlob && uploadBlob.size, 'elapsed(ms)', Date.now() - start)
        } else {
          // eslint-disable-next-line no-console
          console.log('[upload] skip compress (<= threshold)')
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('[upload] compress error, fallback to original', err)
        // 压缩失败则回退原图
        uploadBlob = file
      }
      const formData = new FormData()
      const filenameBase = (file.name || 'image').replace(/\.[^/.]+$/, '')
      const filename = filenameBase + (uploadBlob.type === 'image/jpeg' ? '.jpg' : '')
      formData.append('file', uploadBlob, filename)
      request({
        url: 'https://api.jiaodao11.com/zuul/api/fs/uploadNoSaveWf',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      }).then(res => {
        if (res.resultCode === '1000') {
          const url = res.data.fileUrl
          this.$set(this, this.currentKey.includes('.') ? this.currentKey.split('.')[0] : 'form', {
            ...(this.currentKey.includes('.') ? this[this.currentKey.split('.')[0]] : this.form),
            [this.currentKey.includes('.') ? this.currentKey.split('.')[1] : this.currentKey]: url,
          })
        } else {
          Notify(res.resultDesc || '上传失败')
        }
        e.target.value = ''
      })
    },
    // 将驼峰 key 转为下划线
    toSnakeCaseKey(key) {
      return key
        .replace(/([A-Z])/g, '_$1')
        .replace(/__/g, '_')
        .toLowerCase()
    },
    // 深度转换对象/数组的 key 为下划线风格
    toSnakeCaseDeep(input) {
      if (Array.isArray(input)) {
        return input.map(v => this.toSnakeCaseDeep(v))
      }
      if (input && typeof input === 'object') {
        const out = {}
        Object.keys(input).forEach(k => {
          const v = input[k]
          const nk = this.toSnakeCaseKey(k)
          out[nk] = this.toSnakeCaseDeep(v)
        })
        return out
      }
      return input
    },
    validPhone(p) { return /^1[3-9]\d{9}$/.test(p) },
    // 视为“未上传”的占位地址集合（包含示例图）
    isUploaded(v) {
      const placeholders = [
        PLACEHOLDER,
        ID_CARD_FRONT, ID_CARD_BACK,
        JOB_CER, DRIVER_LICENSE, DRIVER_LICENSE_BACK,
        DRIVER_LICENSE_1, DRIVER_LICENSE_2, DRIVER_LICENSE_3, DRIVER_LICENSE_4,
        REGISTRATION_1, REGISTRATION_2, REGISTRATION_3, REGISTRATION_4,
        INSURANCE_COMPULSORY, INSURANCE_COMMERCIAL,
        INSURANCE_CARRIER_1, INSURANCE_CARRIER_2, INSURANCE_CARRIER_3,
        TRANSPORT_PERMIT, EXTERNAL_INSPECTION_FORM, ONLINE_SHEET,
      ]
      return !!(v && !placeholders.includes(v))
    },
    // 组装提交数据：包含表单所有填写项与上传项
    buildSubmitPayload() {
      const { form, driver_relation, two_drivers, driver1, driver2 } = this
      // 按上传状态与合法性，选择性组装驾驶员字段
      const d1 = {}
      if (this.isUploaded(driver1.id_card)) d1.idCard = driver1.id_card
      if (this.isUploaded(driver1.id_card_back)) d1.idCardBack = driver1.id_card_back
      if (this.isUploaded(driver1.job_cert)) d1.jobCert = driver1.job_cert
      if (this.isUploaded(driver1.driver_license)) d1.driverLicense = driver1.driver_license
      if (this.isUploaded(driver1.driver_license_back)) d1.driverLicenseBack = driver1.driver_license_back
      if (this.validPhone(driver1.phone)) d1.phone = driver1.phone
      
      let d2
      if (two_drivers === '1') {
        d2 = {}
        if (this.isUploaded(driver2.id_card)) d2.idCard = driver2.id_card
        if (this.isUploaded(driver2.id_card_back)) d2.idCardBack = driver2.id_card_back
        if (this.isUploaded(driver2.job_cert)) d2.jobCert = driver2.job_cert
        if (this.isUploaded(driver2.driver_license)) d2.driverLicense = driver2.driver_license
        if (this.isUploaded(driver2.driver_license_back)) d2.driverLicenseBack = driver2.driver_license_back
        if (this.validPhone(driver2.phone)) d2.phone = driver2.phone
      }
      
      return {
        // 基础与关系
        ownerName: form.ownerName,
        plateNo: form.plateNo,
        ownerPhone: form.ownerPhone,
        ownerIdCard: form.ownerIdCard,
        ownerIdCardBack: form.ownerIdCardBack,
        ownerIsDriver: driver_relation,
        twoDrivers: two_drivers,
       
        jobCert: form.ownJobCert,
        county:form.county,
        driverLicense:form.ownDriverLicense,
        driverLicenseBack:form.ownDriverLicenseBack,
        
        //驾驶员档案
        driverArchive: {
          idCard:d1.idCard,
          idCardBack:d1.idCardBack,
          jobCert:d1.jobCert,
          driverLicense: d1.driverLicense,
          driverLicenseBack: d1.driverLicenseBack,
          phone:d1.phone,
          twoIdCard: d2 ? d2.idCard : null,
          twoIdCardBack: d2 ? d2.idCardBack : null,
          twoJobCert: d2 ? d2.jobCert : null,
          twoDriverLicense: d2 ? d2.driverLicense : null,
          twoDriverLicenseBack: d2 ? d2.driverLicenseBack : null,
          twoPhone: d2 ? d2.phone : null,
        },
        // 车辆档案（打包为对象 vehicleArchive）
        vehicleArchive: {
          drivingLicense1: form.drivingLicense1,
          drivingLicense2: form.drivingLicense2,
          drivingLicense3: form.drivingLicense3,
          drivingLicense4: form.drivingLicense4,
          registration1: form.registration1,
          registration2: form.registration2,
          registration3: form.registration3,
          registration4: form.registration4,
          insuranceCompulsory: form.insuranceCompulsory,
          insuranceCommercial: form.insuranceCommercial,
          insuranceCarrier1: form.insuranceCarrier1,
          insuranceCarrier2: form.insuranceCarrier2,
          insuranceCarrier3: form.insuranceCarrier3,
          transportPermit: form.transportPermit,
          externalInspectionForm: form.externalInspectionForm,
          externalInspectionForm2: form.externalInspectionForm2,
          onlineSheet: form.onlineSheet,
          onlineSheet2: form.onlineSheet2,
          onlineSheet3: form.onlineSheet3,
          onlineSheet4: form.onlineSheet4,
          hasExternal: form.hasExternal,
          coc:form.coc,
          invoice:form.invoice,
        },
        // 驾驶员档案（未上传则不赋值；未选择两名驾驶员则不包含 driver2）
   
      }
    },
    handleSubmit() {
      // 基础信息
      if (!this.form.ownerName) return Notify('请输入车主姓名')
      if (!this.form.plateNo) return Notify('请输入车牌号码')
      if (!this.form.ownerPhone || !this.validPhone(this.form.ownerPhone)) return Notify('请输入正确的手机号码')

      // 车辆档案：所有上传项必须上传（基于初始快照判断）
      const drivingKeys = ['drivingLicense1','drivingLicense2','drivingLicense3','drivingLicense4']
      if (!drivingKeys.every(k => this.isUploadedKey(k))) return Notify('请上传全部行驶证1-4页')

      const regKeys = ['registration1','registration2']
      if (!regKeys.every(k => this.isUploadedKey(k))) return Notify('请上传全部登记证书1-4页')

      if (!this.isUploadedKey('insuranceCompulsory')) return Notify('请上传交强险')
      if (!this.isUploadedKey('insuranceCommercial')) return Notify('请上传商业险')

      const carrierKeys = ['insuranceCarrier1']
      if (!carrierKeys.every(k => this.isUploadedKey(k))) return Notify('请至少上传承运人1张，第一张')

      if (!this.isUploadedKey('transportPermit')) return Notify('请上传车辆运输证')

      // 外检/上线：仅当选择“有外检/上线”时必传
      if (this.form.hasExternal == '1') {
        const externalInspectionForms = ['externalInspectionForm','externalInspectionForm2']
        if (!externalInspectionForms.every(k => this.isUploadedKey(k))) return Notify('请上传全部外检表1-2页')

         
         const onlineSheets = ['onlineSheet','onlineSheet2','onlineSheet3','onlineSheet4']
         if (!onlineSheets.every(k => this.isUploadedKey(k))) return Notify('请上传全部上线单1-4页')

        
      }

      // 驾驶员档案：根据同人/不同人、是否有外检、是否两名驾驶员做条件校验）。
      const r1 = this.driver_relation == '1'
      const two = this.two_drivers == '1'

      if (r1) {
        // 车主即驾驶员：身份证(正反面)+上岗证+驾驶证+手机
        if (!(this.isUploadedKey('form.ownerIdCard') && this.isUploadedKey('form.ownerIdCardBack'))) {
          return Notify('请上传驾驶员身份证正反面')
        }
        if (!this.isUploadedKey('form.ownJobCert')) return Notify('请上传上岗证')
        if (!this.isUploadedKey('form.ownDriverLicense')) return Notify('请上传驾驶证')
        if (!this.isUploadedKey('form.ownDriverLicenseBack')) return Notify('请上传驾驶证反面')
       
      } else {
        //把车主上岗证与驾驶证正反赋值为空
        this.form.ownJobCert = null
        this.form.ownDriverLicense = null
        this.form.ownDriverLicenseBack = null

        // 非同人：车主身份证(正反面)
        if (!(this.isUploadedKey('form.ownerIdCard') && this.isUploadedKey('form.ownerIdCardBack'))) {
          return Notify('请上传车主身份证正反面')
        }
        // 1号驾驶员：身份证(正反面)+上岗证+驾驶证(正反面)+手机
        if (!(this.isUploadedKey('driver1.id_card') && this.isUploadedKey('driver1.id_card_back'))) {
          return Notify('请上传1号驾驶员身份证正反面')
        }
        if (!this.isUploadedKey('driver1.job_cert')) return Notify('请上传1号驾驶员上岗证')
        if (!(this.isUploadedKey('driver1.driver_license') && this.isUploadedKey('driver1.driver_license_back'))) {
          return Notify('请上传1号驾驶员驾驶证正反面')
        }
        if (!this.validPhone(this.driver1.phone)) return Notify('请输入1号驾驶员正确的手机号码')

        // 2号驾驶员：当选择两个驾驶员时，全部必传
        if (two) {
          if (!(this.isUploaded(this.driver2.id_card) && this.isUploaded(this.driver2.id_card_back))) {
            return Notify('请上传2号驾驶员身份证正反面')
          }
          if (!this.isUploaded(this.driver2.job_cert)) return Notify('请上传2号驾驶员上岗证')
          if (!(this.isUploaded(this.driver2.driver_license) && this.isUploaded(this.driver2.driver_license_back))) {
            return Notify('请上传2号驾驶员驾驶证正反面')
          }
          if (!this.validPhone(this.driver2.phone)) return Notify('请输入2号驾驶员正确的手机号码')
        }
      }

      //判断是否上传过（非必填）
      if (!this.isUploadedKey('coc')){
        console.log("-isUploadedKey coc-----------",this.isUploadedKey('coc'))
        this.form.coc = "";
      }


      if (!this.isUploadedKey('registration3')){
        this.form.registration3 = "";
      }
      if (!this.isUploadedKey('registration4')){
        this.form.registration4 = "";
      }

      if (!this.isUploadedKey('invoice')){
        this.form.invoice = "";
      }
     if (!this.isUploadedKey('insuranceCarrier2')){
        this.form.insuranceCarrier2 = "";
      }
      if (!this.isUploadedKey('insuranceCarrier3')){
        this.form.insuranceCarrier3 = "";
      }
      if (!this.isUploadedKey('onlineSheet')){
        this.form.onlineSheet = "";
      }
      if (!this.isUploadedKey('onlineSheet2')){
        this.form.onlineSheet2 = "";
      }
      if (!this.isUploadedKey('onlineSheet3')){
        this.form.onlineSheet3 = "";
      }
      if (!this.isUploadedKey('onlineSheet4')){
        this.form.onlineSheet4 = "";
      }
      if (!this.isUploadedKey('externalInspectionForm')){
        this.form.externalInspectionForm = "";
      }
      if (!this.isUploadedKey('externalInspectionForm2')){
        this.form.externalInspectionForm2 = "";
      }



      // 全部校验通过，调用保存接口
      const data = this.buildSubmitPayload()
      //const payload = this.toSnakeCaseDeep(data)
      const urls = Global.env + Global.apiCore.saveVdaMain
      request({ url: urls, method: 'post', data: data }).then(res => {
        if (res && res.resultCode === '1000') {
          Notify({ type: 'success', message:  '档案提交成功,请勿重复提交' })
          this.clearForm()
        } else {
          Notify((res && res.resultDesc) || '提交失败')
        }
      }).catch(() => {
        Notify('网络异常，请稍后重试')
      })
    }
  },
  computed: {
    vehicleProgress() {
      // 车辆档案完成度：行驶证(任一页) + 登记证(任一页) + 任一保险 + 运输证 [+ 外检表 + 上线单]
      const anyDriving = ['drivingLicense1','drivingLicense2','drivingLicense3','drivingLicense4'].some(k=>this.isUploadedKey(k))
      const anyReg = ['registration1','registration2','registration3','registration4'].some(k=>this.isUploadedKey(k))
      const anyIns = ['insuranceCompulsory','insuranceCommercial','insuranceCarrier1','insuranceCarrier2','insuranceCarrier3'].some(k=>this.isUploadedKey(k))
      const transport = this.isUploadedKey('transportPermit')
      const needsExternal = this.form.hasExternal === '1'
      const extForm = needsExternal ? this.isUploadedKey('externalInspectionForm') : true
      const online = needsExternal ? this.isUploadedKey('onlineSheet') : true
      const total = needsExternal ? 6 : 4
      const done = [anyDriving, anyReg, anyIns, transport, extForm, online].slice(0, total).filter(Boolean).length
      return Math.round((done / total) * 100)
    },
    driverProgress() {
      // 驾驶员档案完成度：
      // 车主即驾驶员：身份证+上岗证+驾驶证+手机
      // 否：车主身份证 + （1号驾驶员：身份证/上岗证/驾驶证/手机） [+ （2号同样四项）]
      const r1 = this.driver_relation === '1'
      const two = this.two_drivers === '1'
      if (r1) {
        const items = [this.isUploadedKey('driver1.id_card'), this.isUploadedKey('driver1.job_cert'), this.isUploadedKey('driver1.driver_license'), this.validPhone(this.driver1.phone)]
        const total = 4
        const done = items.filter(Boolean).length
        return Math.round((done / total) * 100)
      }
      // 非同人
      const baseItems = [this.isUploadedKey('ownerIdCard'), this.isUploadedKey('driver1.id_card'), this.isUploadedKey('driver1.job_cert'), this.isUploadedKey('driver1.driver_license'), this.validPhone(this.driver1.phone)]
      let total = 5
      let done = baseItems.filter(Boolean).length
      if (two) {
        const d2 = [this.isUploadedKey('driver2.id_card'), this.isUploadedKey('driver2.job_cert'), this.isUploadedKey('driver2.driver_license'), this.validPhone(this.driver2.phone)]
        total += 4
        done += d2.filter(Boolean).length
      }
      return Math.round((done / total) * 100)
    }
  },
}
</script>

<style rel="stylesheet/scss" lang="scss">
.account-sp{color:red;font-size:0.35rem}
.account-sign{float:right;margin-right:0.5rem}
.button-ce-s{width:100%;text-align:center}
.button-sign{height:0.78667rem;line-height:.78667rem;padding:0 0.73333rem;font-size:.28333rem;background-color:#1e9fff;margin-bottom:1rem;border:none;color:#ffff;font-weight:bold;margin-top:0.3rem}
.img-but{margin-bottom:0.5rem!important}
.img-sign{width:3rem;margin:0.2rem}
.imgs-grid{display:flex;flex-wrap:wrap;justify-content:center}
.select-sgin{width:70%;border:none;font-size:.28rem;height:100%;background-color:#ffff}
.mse-sign{#big-sign{width:100%;height:100%;overflow:hidden;display:flex;flex-direction:column;background:#f9f9f9;}#main-sign{flex:1;background:#ffffff;overflow-y:auto;}}
.table-main-sign1-sign{width:100%;height:auto;background:#fff;overflow:hidden;margin-bottom:0.3rem}
.table-main-sign1-sign p{display:flex;align-items:center;width:99.5%;min-height:0.8rem;line-height:0.8rem;border:0.02rem solid #e6e6e6;margin:0 auto}
.table-main-sign1-sign p a{float:none;display:inline-block;font-size:.28rem;font-weight:400;color:#333;padding:0 .24rem;text-align:left;height:100%;border-right:.02rem solid #e6e6e6;background-color:#FBFBFB;white-space:nowrap}
.inputs-t{flex:1;float:none;width:auto;height:.8rem;line-height:.8rem;color:#666;text-align:left;font-size:.28rem;border:none;margin-left:.06rem;min-width:0}
.table-kfp{height:0.88rem;width:100%;background:#f3f3f4}
.table-kfp p{width:92.5%;height:0.88rem;line-height:0.88rem;margin:0 auto;font-size:0.32rem;color:#666}
.img-but p a{width:100%;float:none;display:block;white-space:nowrap}
/* 分组标题醒目标注 */
.section-chip{display:inline-block;padding:0 .24rem;height:.6rem;line-height:.6rem;border-radius:.06rem;font-weight:600;font-size:.3rem}
.section-chip.car{background:#e6fffb;color:#08979c}
.section-chip.driver{background:#f6ffed;color:#389e0d}
.section-bar{display:block;width:100%;padding:.16rem .24rem;height:auto;line-height:1.2;border-radius:0;font-weight:600;font-size:.3rem}
.section-bar.car{background:#e6fffb;color:#08979c}
.section-bar.driver{background:#f6ffed;color:#389e0d}
.section-panel{border-radius:.06rem;margin-top:.12rem;padding:.2rem .24rem .24rem;background:transparent}
.section-panel.vehicle{border-left:.06rem solid #08979c}
.section-panel.driver{border-left:.06rem solid #389e0d}
.section-title-line{display:flex;align-items:center;justify-content:space-between}
.section-progress{width:100%;height:.1rem;background:#f0f0f0;border-radius:.06rem;overflow:hidden;margin-top:.12rem}
.section-progress__fill{height:100%;width:0;transition:width .3s ease}
.section-progress__fill.car{background:#08979c}
.section-progress__fill.driver{background:#389e0d}
.section-progress-text{font-size:.26rem;color:#666}

/* 档案项上下结构布局（移动端优化）：文字在上，上传在下，统一样式与对齐 */
.archive-item{display:flex;flex-direction:column;align-items:stretch;width:99.5%;margin:0 auto;border:0.02rem solid #e6e6e6;border-radius:.04rem;background:#fff}
.archive-label{width:100%;display:flex;align-items:center;justify-content:flex-start;padding:.16rem .24rem;font-size:.28rem;color:#333;background:#FBFBFB;border-bottom:.02rem solid #e6e6e6;white-space:nowrap}
.archive-content{width:100%;display:flex;align-items:flex-start;justify-content:flex-start;padding:.12rem .12rem .16rem;}
.archive-content .imgs-grid{justify-content:flex-start}
.archive-content .img-sign{margin:.12rem .12rem}
/* 空状态上传占位：虚线框与背景色（加号统一用中央覆盖） */
.img-sign[src=""], .img-sign:not([src]), .img-sign[src="null"], .img-sign[src="undefined"]{min-height:2rem;background:#fafafa;border:.02rem dashed #cfcfcf;border-radius:.06rem}

/* 统一中央加号：从容器伪元素挪到图片伪元素，默认不显示，仅在占位/示例图显示 */
.img-item{position:relative;display:inline-block}
/* 移除容器伪元素的统一显示（避免上传后仍显示） */
.img-item::after{display:none !important; content:none !important}
.img-sign{cursor:pointer;border-radius:.06rem;position:relative}
.img-sign::after{content:'';position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:1rem;height:1rem;background:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><circle cx='32' cy='32' r='30' fill='%231989fa'/><path d='M32 18v28M18 32h28' stroke='%23FFFFFF' stroke-width='6' stroke-linecap='round'/></svg>") no-repeat center/contain;pointer-events:none;opacity:.96;z-index:2;display:none}
/* 占位/示例图：显示加号（挂在图片伪元素上），并保持虚线框样式 */
.img-sign[src=""], .img-sign:not([src]), .img-sign[src="null"], .img-sign[src="undefined"], .img-sign[src*="selfimg.jpeg"]{min-height:2rem;background:#fafafa;border:.02rem dashed #cfcfcf;border-radius:.06rem;z-index:1}
.img-sign[src=""]::after,
.img-sign:not([src])::after,
.img-sign[src="null"]::after,
.img-sign[src="undefined"]::after,
.img-sign[src*="selfimg.jpeg"]::after{display:block}
/* 将所有“示例图”也视为占位（低层级 + 虚线边框 + 显示加号） */
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E8%BA%AB%E4%BB%BD%E8%AF%81%20%E6%AD%A3%E9%9D%A2.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E8%BA%AB%E4%BB%BD%E8%AF%81%E5%8F%8D%E9%9D%A2.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E4%B8%8A%E5%B2%97%E8%AF%81.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E9%A9%BE%E9%A9%B6%E8%AF%81%E5%8F%8D%E9%9D%A2.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%BA%A4%E5%BC%BA%E9%99%A9.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%95%86%E4%B8%9A%E9%99%A9.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%89%BF%E8%BF%90%E4%BA%BA.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%BD%A6%E8%BE%86%E8%BF%90%E8%BE%93%E8%AF%81.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%A4%96%E6%A3%80%E8%A1%A81.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%B8%8A%E7%BA%BF%E5%8D%951.jpg"],
/* 行驶证1-4示例图 */
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%811.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%812.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%813.png"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%A1%8C%E9%A9%B6%E8%AF%814.jpg"],
/* 登记证书1-4示例图 */
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A61.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A62.png"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A63.jpg"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A63.png"],
.img-sign[src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%9C%BA%E5%8A%A8%E8%BD%A6%E7%99%BB%E8%AE%B0%E8%AF%81%E4%B9%A63.png"] { z-index: 3 !important; }
/* 真实图片：抬高层级覆盖加号，从而“隐藏”加号；排除所有示例图 URL */
.img-sign[src]:not([src=""]):not([src="null"]):not([src="undefined"]):not([src*="selfimg.jpeg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E8%BA%AB%E4%BB%BD%E8%AF%81%20%E6%AD%A3%E9%9D%A2.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E8%BA%AB%E4%BB%BD%E8%AF%81%E5%8F%8D%E9%9D%A2.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E4%B8%8A%E5%B2%97%E8%AF%81.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/driver/%E9%A9%BE%E9%A9%B6%E8%AF%81%E5%8F%8D%E9%9D%A2.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%BA%A4%E5%BC%BA%E9%99%A9.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%95%86%E4%B8%9A%E9%99%A9.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E6%89%BF%E8%BF%90%E4%BA%BA.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E8%BD%A6%E8%BE%86%E8%BF%90%E8%BE%93%E8%AF%81.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E5%A4%96%E6%A3%80%E8%A1%A81.jpg"]) 
:not([src="https://jt11.oss-cn-beijing.aliyuncs.com/vda/vehicle/%E4%B8%8A%E7%BA%BF%E5%8D%951.jpg"]) {z-index:3}
/* 占位图虚线边框保留 */
.img-sign[src*="selfimg.jpeg"]{border:.02rem dashed #cfcfcf;background:#fafafa}
  
/* 加号显示通过示例图/空 src 选择器控制，已上传状态由 .img-item::after 文案角标显示，无需再对 .img-sign::after 做兜底控制 */
/* H5 兼容性优化：地区（市/县）选择的布局与等高 */
.region-selects{flex:1;display:flex;align-items:center;margin-left:.06rem;padding-right:0}
.region-selects .inputs-t{flex:initial;width:auto;height:.8rem;line-height:.8rem}
.region-selects .city-input{flex:0 0 2.2rem;background:#FBFBFB;color:#666;padding:0 .16rem;border-radius:0}
.region-selects .county-select{flex:1 1 0;padding:0 .16rem;margin-left:.16rem;min-width:0}
/* 移动端原生 select 的默认箭头/边框处理 */
.region-selects select.inputs-t{-webkit-appearance:none;appearance:none;background-color:transparent;border:0}

/* ========= 上传状态角标（覆盖旧规则） ========= */
/* 默认不显示，分别在未上传/已上传状态下强制显示并设置文案 */
.img-item::after{display:none}
.img-item:not(.uploaded)::after{content:'未上传' !important;display:block !important;position:absolute;bottom:.06rem;right:.06rem;font-size:.2rem;color:#fff;background:rgba(229,57,53,.95);padding:0 .14rem;border-radius:.12rem;line-height:.24rem;height:.24rem;pointer-events:none;z-index:4}
.img-item.uploaded::after{content:'已上传' !important;display:block !important;position:absolute;bottom:.06rem;right:.06rem;font-size:.2rem;color:#fff;background:rgba(46,125,50,.95);padding:0 .14rem;border-radius:.12rem;line-height:.24rem;height:.24rem;pointer-events:none;z-index:4}
/* ======================================= */
  </style>
